module.exports = __webpack_public_path__ + "img/matt_n.51701b4b.png";